/****************************************************
 * Module Name:  EmployeeCustomerProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "./../../api/restAPICall";
import Constants from "./../../constants";

export default class EmployeeCustomerProxy {

    static createEmployeeCustomer = (employecustomer, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/employecustomer",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(employecustomer),
            "application/json",
            0,
            true
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}